module.exports = __webpack_public_path__ + "static/media/clearcookie.cbe2189d.svg";